/**
 * Default secondary link rows (admin can toggle / reorder).
 * @param {(key: string) => string} t
 * @returns {Array<{ id: string, label: string, url: string, active: boolean, type: string, sort_order: number }>}
 */
export function createDefaultSecondaryButtons(t) {
  return [
    {
      id: "menu",
      label: t("secondaryDefaults.menu"),
      url: "",
      active: false,
      type: "menu",
      sort_order: 0,
    },
    {
      id: "website",
      label: t("secondaryDefaults.website"),
      url: "",
      active: false,
      type: "website",
      sort_order: 1,
    },
    {
      id: "call",
      label: t("secondaryDefaults.call"),
      url: "",
      active: false,
      type: "call",
      sort_order: 2,
    },
    {
      id: "location",
      label: t("secondaryDefaults.location"),
      url: "",
      active: false,
      type: "location",
      sort_order: 3,
    },
  ];
}

/**
 * Normalize secondary_buttons from API or use translated defaults.
 * @param {unknown} raw
 * @param {(k: string) => string} t
 */
export function normalizeSecondaryButtonsState(raw, t) {
  if (Array.isArray(raw) && raw.length > 0) {
    return raw
      .map((r, i) => ({
        id: String(r?.id || `row-${i}`),
        label: String(r?.label || "Link"),
        url: String(r?.url || ""),
        active: r?.active !== false,
        type: String(r?.type || "website"),
        sort_order:
          typeof r?.sort_order === "number" && !Number.isNaN(r.sort_order)
            ? r.sort_order
            : i,
      }))
      .sort((a, b) => a.sort_order - b.sort_order);
  }
  return createDefaultSecondaryButtons(t);
}
